// extracted by mini-css-extract-plugin
module.exports = {"imageStyle":"avatar_imageStyle__1VNfd","round":"avatar_round__18W9R"};